import { I18nStringSchema } from '@lifk/types';
import { z } from 'zod';
import { UUIDValidationSchema } from './uuid';
const CategoryIdValidationSchema = z
    .string()
    .min(1)
    .max(128)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Category id must be a lowercase slug');
const CommentCategoryValidationSchema = z.object({
    id: CategoryIdValidationSchema,
    name: I18nStringSchema,
    description: I18nStringSchema.optional(),
    imgURL: z.string().url()
});
// Upserts one custom category on a workshop.
const UpsertWorkshopCommentCategoryValidationSchema = z.object({
    workshopId: UUIDValidationSchema,
    category: CommentCategoryValidationSchema
});
// Removes a custom category, or hides a default one.
// The server can't know which ids are defaults (they come from content), so an id that isn't custom is recorded as hidden.
const DeleteWorkshopCommentCategoryValidationSchema = z.object({
    workshopId: UUIDValidationSchema,
    categoryId: CategoryIdValidationSchema
});
export { CategoryIdValidationSchema, CommentCategoryValidationSchema, DeleteWorkshopCommentCategoryValidationSchema, UpsertWorkshopCommentCategoryValidationSchema };
//# sourceMappingURL=commentCategory.js.map